// Cuánto va a tardar un video de Seedance, para pacear la barra "Generando video…" —
// ADR-2026-09-18-la-barra-del-video-se-pacea-con-lo-que-tarda-de-verdad.
//
// La barra es falsa (el backend no reporta porcentaje): avanza con un easing sobre una
// duración estimada y capea en 97 %. Hasta ahora la columna del modo la paceaba con el
// número de IMAGEN (80 s), así que en un video de 4 minutos clavaba 97 % al minuto y se
// quedaba ahí tres más. Esto le da un número que sale de lo medido.
//
// Medido en `executions` (60 días, `generate_video_creator` exitosos, sin diálogo ni
// multiescena; `duration_ms` = trabajo del worker, la cola suele ser 0):
//
//   calidad      res     video   n    p50    p75
//   estándar     720p    4 s     63   231    262
//   estándar     720p    5 s     15   282    309
//   estándar     720p    10 s    13   253    300
//   estándar     720p    15 s    20   317    386
//   estándar     1080p   4 s     14   242    293
//   profesional  720p    5 s     12   195    354
//   profesional  720p    10 s    4    357    391
//   profesional  720p    15 s    2    416    416
//   profesional  1080p   4 s     5    449    526
//
// La lectura: un piso de unos 200 s que no depende de nada, más un costo por segundo de
// video que en profesional (Seedance 2.5) es mayor; 1080p suma un poco y 480p no resta.
// El modelo apunta entre la mediana y el p75: la barra "casi termina" cuando el video
// suele llegar, y si tarda más, el tope del 97 % la deja esperando sin mentir.

export type CalidadDeVideo = 'basica' | 'profesional';
export type { ResolucionDeVideo } from '../lib/resolucionVideo';
import type { ResolucionDeVideo } from '../lib/resolucionVideo';

const PISO_S: Record<CalidadDeVideo, number> = { basica: 200, profesional: 220 };
const POR_SEGUNDO_S: Record<CalidadDeVideo, number> = { basica: 9, profesional: 13 };
const FACTOR_RESOLUCION: Record<ResolucionDeVideo, number> = { '480p': 1, '720p': 1, '1080p': 1.15 };
const DURACION_POR_DEFECTO_S = 5;

/** Milisegundos que conviene darle a la barra para un video con esta configuración. */
export function estimarDuracionVideoMs(p: {
  quality: CalidadDeVideo;
  resolution: ResolucionDeVideo;
  durationSeconds: number;
}): number {
  const calidad: CalidadDeVideo = p.quality === 'profesional' ? 'profesional' : 'basica';
  const factor = FACTOR_RESOLUCION[p.resolution] ?? 1;
  const segundos =
    Number.isFinite(p.durationSeconds) && p.durationSeconds > 0
      ? p.durationSeconds
      : DURACION_POR_DEFECTO_S;
  const s = (PISO_S[calidad] + POR_SEGUNDO_S[calidad] * segundos) * factor;
  return Math.round(s * 1000);
}
